<template>
    <l-layer-group
        :layer-type="overlay.type"
        v-model:visible="overlay_visible"
        :name="(overlay.name)"
        ref="tracksLayer"
        @ready="onReady()"
    >
<!--        :maxClusterRadius="80"px-->
<!--        :disableClusteringAtZoom="19"-->
        <l-marker-cluster-group
            ref="trackCluster"
            id="shipment-track-cluster"
            :spiderfyOnEveryZoom="false"
            :spiderfyOnMaxZoom="false"
            :showCoverageOnHover="false"
            :zoomToBoundsOnClick="true"
            :chunkedLoading="true"
            :iconCreateFunction="_defaultClusterIconCreate"
            @clusterclick="onClusterClick"
        >
        </l-marker-cluster-group>
        <l-feature-group
            ref="trackPathLayer"
            id="track-path-layer"
        >
        </l-feature-group>
        <l-feature-group
            ref="moveOnTrackLayer"
            id="move-on-track"
        >
        </l-feature-group>
        <l-feature-group
            ref="shipmentGeozoneLayer"
            id="shipment-geozone"
        >
        </l-feature-group>

        <custom-modal v-if="modalWindows?.events" v-bind="{...modalWindows?.events?.props}">
            <template v-for="(event, i) in modalWindowsEvents" :key="i">
                <ShipmentTimelineModalInfo
                    :event="event"
                    :class="[(activePointXid == event?.xid) && 'timeline-modal-info-item__active']"
                    @click="setPoint(event?.xid)"
                >
                    <template v-slot:icon>
                        <span class="timeline-custom-icon"
                              :class="[
                                  event.type == 'start' && 'timeline-custom-icon__point-start',
                                  event.type == 'end' && 'timeline-custom-icon__point-end',
                              ]"
                              v-if="event.icon">
                            <img class="timeline-custom-icon__icon icon" :src="require('@/assets/img/shipments/'+event?.icon?.name+'.svg')" :alt="event?.icon?.name">
                        </span>
                        <span class="timeline-custom-text" v-else>{{ event.index }}</span>
                    </template>
                </ShipmentTimelineModalInfo>
            </template>

        </custom-modal>

    </l-layer-group>
</template>

<script>
// import {movingMarker as L_movingMarker} from "@/components/app/map/MovingMarker";
import {LFeatureGroup, LLayerGroup} from "@vue-leaflet/vue-leaflet";
import { LMarkerClusterGroup } from 'vue-leaflet-markercluster';
import {mapGetters} from "vuex";
import debounce from "lodash/debounce";
import {buildIconObject,/*getImageOptions,*/ htmlToElement} from "@/lib/lib";
import ShipmentTimelineModalInfo from "@/components/shipment/ShipmentTimelineModalInfo";

export default {
    setup() {
        return {
            debounceUpdate: debounce((fn) => fn(), 400),
        }
    },
    name: "SectionMap_layer_shipments_tracks",
    emits: ['update:modelValue'],
    mixins: [],
    inject: ['L', 'mapLeafletObject', 'toast'],
    props: {
        modelValue: Object,
    },
    components: {
        LLayerGroup,
        LFeatureGroup,
        LMarkerClusterGroup,
        ShipmentTimelineModalInfo,
    },
    data() {
        return {
            trackControlPointsLayerClusterL: null,
            trackControlPointsLayerCluster: null,
            tracksLayer: null,
            trackLayers: null,
            modalWindows: {},
            trackPointsIds: [],
            dateNow: null,
        }
    },
    computed: {
        ...mapGetters([
            "getShipmentsTracks",
            "getShipmentsAlerts",
            "getShipments",
            "getShipmentsById",
            "getShipmentsPackagesById",
        ]),
        packageId() {
            return this.routeFilter.packageId
        },
        shipmentsPackage() {
            return this.getShipmentsPackagesById[this.packageId]
        },
        shipmentId() {
            return this.routeFilter.shipmentId
        },
        shipment() {
            return this.getShipmentsById[this.shipmentId];
        },
        isShipmentEdit() {
            return [this.$consts.routerNames?.shipment?.editView, this.$consts.routerNames?.shipment?.packageIdEdit].includes(this.routeName)
        },
        shipmentAlerts() {
            return this.getShipmentsAlerts
                .filter(a => a.shipmentId == this.shipmentId)
                //.filter(a => a.latlng)
                .map(a => {
                    let latlng = a.latlng || []
                    return {
                        ...a,
                        latlng: {lat: latlng[0], lng: latlng[1]},
                        icon: buildIconObject(a.image, a.type)
                    }
                })
        },
        routes() {
            return this.packageId ? this.shipmentsPackage?.routes : this.shipment?.routes
        },
        routeStart() {
            return this.routes?.find(r => r.stop_order == 0)
        },
        routeEnd() {
            return this.routes?.find(r => r.stop_order == 1)
        },
        shipmentActualStartTime() {
            return this.shipment?.started__time
        },
        shipmentActualEndTime() {
            return this.shipment?.completed__time
        },
        activePointXid() {
            return this.routeFilter.shipmentTrackPoint
        },
        activePoint() {
            let p = [...this.shipmentStartEndPoints, ...this.trackPoints]?.find(t => t.shipmentId == this.shipmentId && t.xid == this.activePointXid)
            return this.activePointXid ? p : null
        },
        activePointLatLngs() {
            let latlng = null
            if(this?.activePoint?.latlng) {
                latlng = this?.activePoint?.latlng
                latlng = [{lat: latlng.lat, lng: latlng.lng}]
            }
            if(this?.activePoint?.latLng) {
                latlng = [this?.activePoint?.latLng]
            }
            return latlng
        },
        startEndPoint() {
            return this.isShipmentEdit ? JSON.stringify(this.routes) : '';
        },
        shipmentRoutesLatLng() {
            return this.routes?.map(r => {
                let coordinates = r?.address?.coordinates
                return {lat: coordinates?.latitude, lng: coordinates?.longitude}
            })?.filter(r => r.lat && r.lng) || []
        },
        lastTrackPointLatLng() {
            let point = this.trackPoints[this.trackPoints.length - 1]
            return point ? [point.latLng] : []
        },
        shipmentStartEndPoints() {
            let fromCoordinates = this.routeStart?.address?.coordinates
            let toCoordinates = this.routeEnd?.address?.coordinates
            let fromAddress = this.routeStart?.address?.address;
            let toAddress = this.routeEnd?.address?.address;
            let fromRadius = this.routeStart?.address?.radius;
            let toRadius = this.routeEnd?.address?.radius;

            let startEnd = [
                {
                    xid: 'start',
                    type: 'start',
                    shipmentId: this.shipmentId,
                    stop_order: 0,
                    latLng: {lat: fromCoordinates?.latitude, lng: fromCoordinates?.longitude},
                    icon: buildIconObject('shipment__point'),
                    time_start: this.shipment?.shipping__time,
                    radius: fromRadius,
                    address: [
                        fromAddress?.street,
                        fromAddress?.locality,
                        fromAddress?.state,
                        fromAddress?.country,
                        fromAddress?.postalCode
                    ].filter(v=>v).join(', '),
                },
                {
                    xid: 'end',
                    type: 'end',
                    shipmentId: this.shipmentId,
                    stop_order: 1,
                    latLng: {lat: toCoordinates?.latitude, lng: toCoordinates?.longitude},
                    icon: buildIconObject('shipment__point'),
                    time_end: this.shipment?.delivery__time,
                    radius: toRadius,
                    address: [
                        toAddress?.street,
                        toAddress?.locality,
                        toAddress?.state,
                        toAddress?.country,
                        toAddress?.postalCode
                    ].filter(v=>v).join(', '),
                }
            ].filter(p => p.latLng.lat && p.latLng.lng)
            return this.routes?.length ? startEnd : [];
        },
        modalWindowsEvents() {
            return this.trackPoints.filter(p => this.trackPointsIds.includes(p?.time?.utc))
        },
        overlay() {
            return this.modelValue
        },
        overlay_visible: {
            get() {
                return this.overlay?.visible
            },
            set(vl) {
                this.$emit('update:modelValue', {...this.overlay, visible: vl})
            },
        },
        track() {
            let track = [...this.getShipmentsTracks, ...this.shipmentAlerts]
                .filter(t => t.shipmentId == this.shipment?.id && t?.time?.utc >= this.shipmentActualStartTime?.utc && t?.time?.utc <= (this.shipmentActualEndTime?.utc || this.dateNow))

            track.sort((a, b) => {
                return a?.time?.utc - b?.time?.utc
            })

            return track
        },
        trackPoints() {
            return this.track
                .filter(t => !!t?.latlng?.lat && !!t?.latlng?.lng)
                .map((p, i) => {
                    let latlng = p?.latlng
                    let address = p.address;
                    let latLng = {lat: latlng?.lat, lon: latlng?.lng};
                    let icon = p.icon || ''//alert['sub-type'] shipment__point.svg

                    return {
                        xid: p?.xid,
                        shipmentId: p.shipmentId,
                        type: 'track',
                        index: i + 1,
                        latLng,
                        time: p?.time,
                        address,
                        icon,
                        text: p?.text || '',
                        sensors: p?.sensors || {}
                    };
                });
        },
        // mapSize() {
        //     return this.mapLeafletObject._size
        // },
        watchTrackUpdate() {
            return [this.shipmentId, this.packageId, this.activePointXid, this.track?.length, this.startEndPoint].join('/')
        },
    },
    watch: {
        routeFilter: {
            handler: function () {
                if(this.mainRouteName == this.$consts.routerNames?.shipment?.main) {
                    this.updateDebounce()
                }
            },
            deep: true,
        },
        watchTrackUpdate: {
            handler: function (newTrack, oldTrack) {
                if (newTrack != oldTrack) {
                    this.debounceUpdate(this.updateUnitTrack)
                }
            },
            //deep: true,
            immediate: true
        },
    },
    methods: {
        updateDebounce() {
            let fitBebounce = []
            if(this.activePointLatLngs) {
                fitBebounce = this.activePointLatLngs
            } else
            if(!this.shipment?.status || this.shipment?.status === 'completed') {
                fitBebounce = this.shipmentRoutesLatLng
            } else
            if(this.shipment?.status === 'started' && this.shipment?.changed__time > 0) {
                fitBebounce = this.lastTrackPointLatLng
            }

            if(fitBebounce?.length) {
                this.fitBounds(fitBebounce)
            }
        },
        updateRouteAddress(marker) {
            let latLng = marker.getLatLng();
            let stop_order = marker?.meta?.stop_order
            this.$api.locations
                .resolveAddress(latLng)
                .then((response) => {
                    if (response.data.status == 'ZERO_RESULTS' || !this.isShipmentEdit) {
                        this.toast.error('Not Coordinates')
                        return false;
                    }
                    let data = response.data[0]
                    this.shipment.routes = this.shipment?.routes?.map(r => {
                        if (r.stop_order == stop_order) {
                            r = {
                                ...r,
                                address: {
                                    name: data?.address?.name,
                                    coordinates: data?.address?.coordinates,
                                    address: data?.address.address,
                                    radius: this.getGeoitemEdit?.radius
                                }
                            }
                        }
                        return r;
                    })
                })
        },
        modalClose () {
            this.modalWindows = {}
            this.trackPointsIds = []
        },
        showModal(times) {
            this.trackPointsIds = times
            this.modalWindows = {
                events: {
                    props:{
                        title: this.$t('Shipment.Points'),
                        btnOkClass: 'btn-ok button_theme_neutral',
                        modalClass: 'modal_hide_close-btn modal-600' + ' ' + (this.$consts.routerNames?.shipment?.map === this.routeName ? 'modal-content-left' : ''),
                        buttons:[
                            {id: 'ok', fn: () => this.modalClose()},
                            {id: 'cancel', fn: () => this.modalClose()},
                        ],
                        btnCanselText: 'Ok',
                    }
                }
            }
        },
        setPoint(xid) {
            this.setRoute.shipmentTrackPoint(this.$route, this.$router, xid)
        },
        createTrack(track) {
            let trackLayers = [];

            track.sort(function (a,b) {
                return a.time.utc - b.time.utc
            })

            let latLngs = track.map(t => t.latlng)
            .filter(t => t.lat && t.lng)

            let options = {
                color: '#00ff0e',
                opacity: 1,
                noClip: true,
                smoothFactor: 3,
                weight: 1,
                dashArray: '5,10',
            }

            let trackPoly = new this.L.Polyline(latLngs, options)
            trackLayers.push(trackPoly);//ToDo ???

            if (!trackLayers.length) {
                return false;
            }

            return {
                layer: new this.L.FeatureGroup(trackLayers),
                id: 1
            };
        },
        /*async*/ updateUnitTrack() {
            // if(this.$isDevelopment) console.log('updateUnitTrack', this.track)
            this.trackPathLayer.clearLayers()
            this.trackControlPointsLayerCluster.clearLayers()
            this.shipmentGeozoneLayer.clearLayers()

            for (const [index, t] of this.shipmentStartEndPoints.entries()) {
                let marker, options
                options = {
                    draggable: this.routeName == this.$consts.routerNames.shipment.editView && (!this.shipment?.status || (this.shipment?.status == 'started' && t.stop_order == 0)),
                    meta: {
                        ...t,
                    }
                }
                marker = /*await*/ this.createMarker(t.latLng, options)

                marker
                    .off("drag")
                    .on("drag", (e) => {
                        let marker = e.target;
                        this.debounceUpdate(() => this.updateRouteAddress(marker))
                    });

                if (marker) {
                    let radius = t?.radius || this.$consts?.shipment?.route?.radius;
                    if(radius) {
                        let geo = this.L.circle(
                            t.latLng,
                            {
                                radius,
                                meta: {stop_order: t.stop_order},
                                color: (t.type === 'start' ? this.$consts?.shipment?.route?.color?.start : this.$consts?.shipment?.route?.color?.end)
                            }
                        )
                        this.shipmentGeozoneLayer.addLayer(geo)
                    }
                    marker.meta['sUniqueKey'] = t.type + '_point_' + index
                    marker.addTo(this.trackPathLayer)
                }
            }

            if (!this.track?.length) return false;

            let markers = this.trackPoints
                .map((p, i) => {
                    let marker = /*await*/ this.createMarker(p.latLng, {
                        meta: {...p,'sUniqueKey': i + '_point'}
                    })
                    marker.on('click', () => {
                        this.showModal([marker.meta.time.utc])
                    })
                    return marker
                })
            this.trackControlPointsLayerCluster.addLayers(markers)
        },
        fitBounds(trackBounds){
            let paddingBounds = {
                paddingTopLeft: [50, 50],
                paddingBottomRight: [50, 50],
            }
            setTimeout(() => {
                if(this.$isDevelopment) console.log(trackBounds)
                this.mapLeafletObject.fitBounds(trackBounds, paddingBounds)
            }, 300)
        },
        createMarker(latLng, options = {}) {
            // let markerOptions = await getImageOptions(options.icon)
            // let iconSize = markerOptions?.icon?.iconSize
            // if (!markerOptions || !(iconSize[0] * iconSize[1])) {
            //     console.error('createMarker', markerOptions?.icon)
            //     return null;
            // }
            // let iconAnchor = iconSize.map((sz, i) => sz * (options.icon?.anchorK[i] || 0))
            // let popupAnchor = iconSize.map((sz, i) => sz * (options.popup?.anchorK[i] || 0))
            // let tooltipAnchor = iconSize.map((sz, i) => sz * (options.tooltip?.anchorK[i] || 0))
            let meta = {...options.meta}
            delete options.meta
            let html = htmlToElement('' +
                '<div class="shipment-track-point">' + (
                    meta.icon ?
                        `<div class="shipment-track-point__text shipment-track-point__${meta.type}"><img src="${require('@/assets/img/shipments/'+meta?.icon?.name+'.svg')}" alt="${meta?.icon?.name}"></div>` :
                        `<div class="shipment-track-point__text">${meta.index}</div>`
                ) +
                `<div class="shipment-track-point__line"><div class="shipment-track-point__line-point"></div></div>`+
                '</div>'
            )

            let markerOptions = {
                ...options,
                //...markerOptions,
                icon: this.L.divIcon({
                    className: 'shipment-icon ' + meta.className,
                    iconSize: [94, 56],
                    iconAnchor: [94/2, 56],
                    html,
                }),
            }

            if (!Array.isArray(latLng) && typeof latLng === 'string') latLng = latLng.split(',')
            let marker = this.L.marker(latLng, markerOptions);
            marker.meta = meta
            return marker
        },
        clusterIconCreate(cluster) {
            let html = ('' +
                '<div class="shipment-track-cluster">' +
                '<div class="shipment-track-cluster__text shipment-track-cluster__group">' +
                `<img src="${require('@/assets/img/shipments/shipment__group.svg')}" alt="${cluster.getChildCount()}">` +
                //cluster.getChildCount() +
                '</div>' +
                `<div class="shipment-track-cluster__line"><div class="shipment-track-cluster__line-point"></div></div>`+
                '</div>'
            )
            return this.L.divIcon({
                //className: '',
                //iconSize: [94, 56],
                //iconAnchor: [47, 28],
                html,
            });
        },
        _defaultClusterIconCreate(cluster) {
            let childCount = cluster.getChildCount();

            let c = ' marker-cluster-';
            if (childCount < 10) {
                c += 'small';
            } else
            if (childCount < 100) {
                c += 'medium';
            } else {
                c += 'large';
            }

            return this.L.divIcon({
                className: 'marker-cluster ' + c,
                html: '<div class="shipment-track-cluster"><span>' + childCount + '</span></div>',
                iconSize: [40,40],
            });
        },
        onClusterClick(a) {
            if(this.$isDevelopment) console.log('cluster ' + a.layer.getAllChildMarkers().length);
            let times = a.layer.getAllChildMarkers().map(m => m.meta.time.utc)
            this.showModal(times)
        },
        onReady() {
            this.trackControlPointsLayerCluster = this.$refs.trackCluster.leafletObject
            this.shipmentGeozoneLayer = this.$refs.shipmentGeozoneLayer.leafletObject
            this.tracksLayer = this.$refs.tracksLayer.leafletObject
            this.trackPathLayer = this.$refs.trackPathLayer.leafletObject
            this.moveOnTrackLayer = this.$refs.moveOnTrackLayer.leafletObject
        },
        updateDateNow() {
            this.dateNow = Date.now() / 1000
        },
        clearInterval() {
            if(this.interval) {
                clearInterval(this.interval)
                this.interval = null
            }
        }
    },
    created() {
        this.interval = setInterval(() => this.updateDateNow(), 10000);
    },
    mounted() {
    },
    updated() {
        if(this.$isDevelopment) console.log('updated', this._.type.name)
    },
    beforeUnmount() {
        clearInterval()
    }
}
</script>

<style scoped lang="scss">
.timeline-custom-icon {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    &__icon {
        width: 100%;
    }
    &__point-start {
        border-radius: 100%;
        background: rgb(4, 122, 251);

        .icon {
            width: 60%;
        }
    }
    &__point-end {
        border-radius: 100%;
        background: rgb(40, 178, 95);

        .icon {
            width: 70%;
        }
    }
}
.timeline-custom-text {
    background: #3684DB;
    border-radius: 100%;
    min-height: 30px;
    min-width: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    @include font(10px, normal, 700, none, normal, white);
}
</style>